/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

export type EvtCreateTokenBadge = { tokenMint: Address };

export type EvtCreateTokenBadgeArgs = EvtCreateTokenBadge;

export function getEvtCreateTokenBadgeEncoder(): FixedSizeEncoder<EvtCreateTokenBadgeArgs> {
  return getStructEncoder([["tokenMint", getAddressEncoder()]]);
}

export function getEvtCreateTokenBadgeDecoder(): FixedSizeDecoder<EvtCreateTokenBadge> {
  return getStructDecoder([["tokenMint", getAddressDecoder()]]);
}

export function getEvtCreateTokenBadgeCodec(): FixedSizeCodec<
  EvtCreateTokenBadgeArgs,
  EvtCreateTokenBadge
> {
  return combineCodec(
    getEvtCreateTokenBadgeEncoder(),
    getEvtCreateTokenBadgeDecoder(),
  );
}
